import * as React from "react";

export default class LoadingContainer extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
    }

    public render() {

        return (
            this.props.showProgress ? (<div style={{zIndex: 100}} className='loader' ></div>) : this.props.display
        );
    }
}